// src/components/HealthTrendIcon.js
import React from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import RemoveIcon from "@mui/icons-material/Remove";
import { Tooltip } from "@mui/material";

/**
 * HealthTrendIcon: Shows a simple trend arrow for provider health.
 * @param {"up"|"down"|"flat"} trend
 */
const HealthTrendIcon = ({ trend }) => {
  if (trend === "up") {
    return (
      <Tooltip title="Improved" arrow>
        <ArrowUpwardIcon fontSize="small" style={{ color: '#43a047' }} />
      </Tooltip>
    );
  }
  if (trend === "down") {
    return (
      <Tooltip title="Declined" arrow>
        <ArrowDownwardIcon fontSize="small" style={{ color: '#e53935' }} />
      </Tooltip>
    );
  }
  return (
    <Tooltip title="No change" arrow>
      <RemoveIcon fontSize="small" style={{ color: '#bdbdbd' }} />
    </Tooltip>
  );
};

export default HealthTrendIcon;
